import * as React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import GCashConsent from '../../../../components/home/GCashConsent/GCashConsent'

const StyledGCashConsent = styled(GCashConsent)`
  padding: 1rem;
`

function MainView() {
  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
        display: none !important;
      }`}
        </style>
      </Helmet>
      <StyledGCashConsent />
    </>
  )
}

export default MainView
